import { render, staticRenderFns } from "./ShortPlayDialog.vue?vue&type=template&id=64c5da62&scoped=true&"
import script from "./ShortPlayDialog.vue?vue&type=script&lang=js&"
export * from "./ShortPlayDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShortPlayDialog.vue?vue&type=style&index=0&id=64c5da62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5da62",
  null
  
)

export default component.exports